// import styles from "./CustomerList.module.scss";select
import FormButtons from "./../InformationsForms/FormButtons";
import React, { useState, useEffect, useContext } from "react";
import { baseUrl } from "../../common/constants";
import { toast } from "react-toastify";
import { mainContext } from "../../context/context";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import _axios from "../../utils/api/_axios";
import { EditOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { Col, Form, Row, Select, Typography } from "antd";
import TextArea from "antd/es/input/TextArea";
import SearchDoctor from "../SearchDoctor";
import { useParams } from "react-router-dom";
import SlotPicker, { to12h } from "../Availability/SlotPicker";

const { Option } = Select;

const AppointmentForm = ({
  onSubmit,
  handleClose,
  isReschedule = false,
  patientId = "",
  claimId = "",
  claim = {},
  isForm = true,
  fetchClaims,
  setSelectedClaim
}) => {
  const [isAlreadyRescheduled, setIsAlreadyRescheduled] = useState(false);
  const [isEditing, setIsEditing] = React.useState(true);
  const [noAppointments, setNoAppointments] = React.useState(false);
  const { currentTab, activeTab } = useContext(mainContext);
  const [checked, setChecked] = useState(false);
  const [selectedTime, setSelectedTime] = useState("");
  const {id} = useParams();
  const [formValues, setFormValues] = useState({
    doctorId: "",
    doctorName: "",
    officeId: "",
    officeName: "",
    offices: [],
    doctors: [],
    visitDate: null,
    visitTime: "",
    description: "",
    reportDueByDate: null,
    rescheduled: false,
  });
  const [isFormInvalid, setIsFormInvalid] = useState(false);
  const [doctorNameValue, setDoctorNameValue] = useState("");
  const [officeNameValue, setOfficeNameValue] = useState("");
  const [doctorSelectValue, setDoctorSelectValue] = useState("");
  const [officeSelectValue, setOfficeSelectValue] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [description, setDescription] = useState("");
  const [selectedReportDueDate, setSelectedReportDueDate] = useState(null);
  // Availability: when the doctor has a schedule at the chosen office we require
  // a slot; otherwise fall back to the legacy free-text time input.
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [noSchedule, setNoSchedule] = useState(false);
  let activeAppointment;

  const handleTimeInputChange = (event) => {
    const inputValue = event.target.value;
    setSelectedTime(inputValue);
    setFormValues({
      ...formValues,
      visitTime: inputValue,
    });
  };

  // Convert Date object to ISO string for API
  const formatDateForAPI = (date) => {
    if (!date) return null;
    if (typeof date === "string") {
      // Try to parse the string to a Date
      const parsedDate = new Date(date);
      if (isNaN(parsedDate)) return null;
      return parsedDate.toISOString();
    }
    return date.toISOString();
  };

  // Format date for display (MM-DD-YYYY)
  const formatDateForDisplay = (date) => {
    if (!date) return "";

    let dateObj;
    if (typeof date === "string") {
      dateObj = new Date(date);
      if (isNaN(dateObj)) return "";
    } else {
      dateObj = date;
    }

    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    const year = dateObj.getFullYear();

    return `${month}-${day}-${year}`;
  };

  // Parse string date to Date object
  const parseStringToDate = (dateStr) => {
    if (!dateStr) return null;
    if (dateStr instanceof Date) return dateStr;

    const date = new Date(dateStr);
    return isNaN(date) ? null : date;
  };

  const handleDateChange = (date) => {
    if (date instanceof Date && !isNaN(date)) {
      setSelectedDate(date);
      setFormValues({
        ...formValues,
        visitDate: date,
      });
    } else {
      console.error("Invalid date selected");
      setSelectedDate(null);
      setFormValues({
        ...formValues,
        visitDate: null,
      });
    }
  };

  const handleReportDueByDateChange = (date) => {
    if (date instanceof Date && !isNaN(date)) {
      setSelectedReportDueDate(date);
      setFormValues({
        ...formValues,
        reportDueByDate: date,
      });
    } else {
      setSelectedReportDueDate(null);
      setFormValues({
        ...formValues,
        reportDueByDate: null,
      });
    }
  };

  const handleDescriptionChange = (event) => {
    const inputValue = event.target.value;
    setDescription(inputValue);
    setFormValues({
      ...formValues,
      description: inputValue,
    });
  };

  const officeChangeHandler = (value) => {
    if (value == "-1") {
      return;
    }
    const selectedOfficeId = value;
    const selectedOffice = formValues?.offices?.find(
      (office) => office?._id === selectedOfficeId
    );
    setOfficeSelectValue(selectedOfficeId);
    setOfficeNameValue(selectedOffice?.hospitalName);
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      officeId: selectedOfficeId,
      officeName: selectedOffice?.hospitalName,
    }));
  };

  const doctorChangeHandler = (value) => {
    if (value === "-1") {
      return;
    }
    setOfficeSelectValue("");
    const selectedDoctorId = value;
    const selectedDoctor = formValues.doctors.find(
      (doctor) => doctor._id === selectedDoctorId
    );
    setDoctorSelectValue(selectedDoctorId);
    setDoctorNameValue(
      `${selectedDoctor?.physicianFirstName} ${selectedDoctor?.physicianLastName}`
    );
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      doctorId: value,
      doctorName: `${selectedDoctor?.physicianFirstName} ${selectedDoctor?.physicianLastName}`,
    }));

    if (value !== "0") {
      fillOffices(selectedDoctorId);
    }
  };

  const isFormValid = () => {
    const timeOk = noSchedule ? !!selectedTime : !!selectedSlot;
    return (
      !!doctorSelectValue &&
      !!officeSelectValue &&
      !!selectedDate &&
      timeOk
    );
  };

  const [message, setMessage] = useState("");
  const map = (formValues) => {
    return {
      appointment: {
        doctorId: formValues.doctorId || doctorSelectValue,
        doctorName: formValues.doctorName || doctorNameValue,
        officeId: formValues.officeId || officeSelectValue,
        officeName: formValues.officeName || officeNameValue,
        visitDate: formatDateForAPI(selectedDate || formValues.visitDate),
        visitTime: selectedSlot ? selectedSlot.startTime : (selectedTime || formValues.visitTime),
        visitEndTime: selectedSlot ? selectedSlot.endTime : (formValues.visitEndTime || null),
        description: formValues.description,
        reportDueByDate: formatDateForAPI(
          selectedReportDueDate || formValues.reportDueByDate
        ),
        rescheduled: formValues.rescheduled,
      },
    };
  };

  const handlePrintAppointment = (patientId, claimId) => {
    const url = `/apt-letter/${patientId}/${claimId}`;
    window.open(url, "_blank", "noopener noreferrer");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    let claimIdd;
    if (!isFormValid()) {
      setIsFormInvalid(true);
      toast.error(
        noSchedule
          ? "Please select a doctor, office, date, and time before submitting"
          : "Please select a doctor, office, date, and an open time slot before submitting"
      );
      return;
    }
    if (patientId && claim?._id) {
      claimIdd = claim?._id;
    }
    if (onSubmit) {
      claimIdd = claimId;
    }
    if (isAlreadyRescheduled === true) {
      toast.error("This appointment has already been rescheduled once.");
      return;
    }
    if (patientId && claimIdd) {
      try {
        let res = await _axios.put(
          `${baseUrl}/patients/${patientId}/claims/${claimIdd}/appointment`,
          map(formValues),
          {
            headers: {
              "Content-Type": "application/json",
            },
            cache: "no-cache",
          }
        );
        let resJson = res.data;
        if (res.status === 200) {
          if (!isReschedule) {
            const statusUpdate = { status: "Scheduled" };
            let response = await _axios.put(
              `${baseUrl}/patients/${patientId}/claims/${claimIdd}/status`,
              statusUpdate,
              {
                headers: {
                  "Content-Type": "application/json",
                },
                cache: "no-cache",
              }
            );
          }
          if(window.location.pathname === `/patient-info/${id}`){
            // const response = fetchClaims(patientId);
            // setSelectedClaim(response?.data?.payload?.find(claim => claim._id === claimId))
            window.location.reload();
          }
          toast.success("Successfully Scheduled appointment.");
          setTimeout(() => {
            handlePrintAppointment(patientId, claimIdd);
          }, 700);
          if (typeof onSubmit === "function") {
            onSubmit();
          }
          handleEditClose();
        } else {
          toast.error("Unable to submit. Some error occurred");
        }
      } catch (err) {
        toast.error(
          "Error scheduling appointment: " +
            (err.response?.data?.message || err.message)
        );
      }
    } else {
      toast.error("Unable to submit. please select a patient to bind with");
    }
    setIsFormInvalid(false);
  };

  const setValues = (payload) => {
    const updatedValues = {};
    if (Array.isArray(payload)) {
      activeAppointment = payload.find((appointment) => appointment.isActive);
      if (activeAppointment) {
        updatedValues.doctorId = activeAppointment.doctorId;
        updatedValues.officeId = activeAppointment.officeId;
        updatedValues.doctorName = activeAppointment.doctorName;
        updatedValues.officeName = activeAppointment.officeName;
        updatedValues.visitDate = parseStringToDate(
          activeAppointment.visitDate
        );
        updatedValues.visitTime = activeAppointment.visitTime;
        updatedValues.description = activeAppointment.description;
        updatedValues.reportDueByDate = parseStringToDate(
          activeAppointment.reportDueByDate
        );

        if (updatedValues.doctorId) {
          const selectedDoctor = formValues.doctors.find(
            (doctor) => doctor._id === updatedValues.doctorId
          );
          setDoctorNameValue(
            `${selectedDoctor?.physicianFirstName} ${selectedDoctor?.physicianLastName}`
          );
        }
        if (updatedValues.officeId) {
          setOfficeSelectValue(activeAppointment.officeId);
          const selectedOffice = formValues.offices.find(
            (office) => office._id === updatedValues.officeId
          );
          setOfficeNameValue(selectedOffice?.hospitalName);
        }
        if (updatedValues.visitTime) {
          setSelectedTime(activeAppointment.visitTime);
          if (activeAppointment.visitEndTime) {
            setSelectedSlot({ startTime: activeAppointment.visitTime, endTime: activeAppointment.visitEndTime });
          }
        }
        if (updatedValues.visitDate) {
          setSelectedDate(updatedValues.visitDate);
        }
        if (updatedValues.reportDueByDate) {
          setSelectedReportDueDate(updatedValues.reportDueByDate);
        }
        if (activeAppointment?.doctorId && activeAppointment?.officeId) {
          updatedValues.rescheduled = true;
        }
        if (
          activeAppointment?.rescheduled &&
          activeAppointment.rescheduled === true
        ) {
          setIsAlreadyRescheduled(true);
        }
      }
    } else {
      updatedValues.doctorId = payload.doctorId;
      updatedValues.officeId = payload.officeId;
      updatedValues.doctorName = payload.doctorName;
      updatedValues.officeName = payload.officeName;
      updatedValues.visitDate = parseStringToDate(payload.visitDate);
      updatedValues.visitTime = payload.visitTime;
      updatedValues.description = payload.description;
      updatedValues.reportDueByDate = parseStringToDate(
        payload.reportDueByDate
      );

      if (payload.doctorId) {
        setDoctorSelectValue(payload.doctorId);
      }
      if (payload.officeId) {
        setOfficeSelectValue(payload.officeId);
      }
      if (payload.visitTime) {
        setSelectedTime(payload.visitTime);
        if (payload.visitEndTime) {
          setSelectedSlot({ startTime: payload.visitTime, endTime: payload.visitEndTime });
        }
      }
      if (payload.visitDate) {
        setSelectedDate(updatedValues.visitDate);
      }
      if (payload.reportDueByDate) {
        setSelectedReportDueDate(updatedValues.reportDueByDate);
      }
      if (payload?.doctorId && payload?.officeId) {
        updatedValues.rescheduled = true;
      }
      if (payload?.rescheduled && payload.rescheduled === true) {
        setIsAlreadyRescheduled(true);
      }
    }

    updatedValues.offices = payload.offices;
    updatedValues.doctors = payload.doctors;

    setFormValues({
      ...formValues,
      ...updatedValues,
    });

    // Set description state to match formValues
    if (updatedValues.description) {
      setDescription(updatedValues.description);
    }
  };

  const setOffices = (payload) => {
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      offices: payload,
    }));
  };

  const setDoctors = (payload) => {
    let doctorlist = payload?.message ? [] : payload;
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      doctors: doctorlist,
    }));
  };

  const getDoctors = async () => {
    try {
      let res = await _axios.get(`${baseUrl}/physician/get-all`, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      let response = res.data;
      return response.payload;
    } catch (err) {
      console.log(err);
      return [];
    }
  };

  const fillOffices = async (doctorId) => {
    let offices = await getOffices(doctorId);
    if (offices && offices.length) {
      setOffices(offices);
    } else {
      setOffices([]);
    }
  };

  const getOffices = async (doctorId) => {
    try {
      const res = await _axios.get(
        `${baseUrl}/hospitalPhysician/physician/${doctorId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      let resJson = res.data.payload;
      if (res.status === 200) {
        setMessage("Offices fetched successfully");
      } else {
        setMessage("Some error occurred");
      }
      return resJson;
    } catch (err) {
      console.log(err);
      return [];
    }
  };

  const enrichPayload = async (payload) => {
    if (
      typeof payload === "undefined" ||
      (Array.isArray(payload) && payload.length === 0) ||
      (typeof payload === "object" &&
        Object.keys(payload).length === 0 &&
        isForm === false)
    ) {
      setNoAppointments(true);
    }
    if (!payload) {
      payload = {};
    }

    try {
      payload.doctors = await getDoctors();

      if (Array.isArray(payload)) {
        const activeAppointment = payload.find(
          (appointment) => appointment.isActive
        );
        if (activeAppointment) {
          if (activeAppointment.officeId && activeAppointment.doctorId) {
            let offices = await getOffices(activeAppointment.doctorId);
            payload.offices = offices?.length ? offices : [];
          }
          setDoctorSelectValue(payload?.appointment?.doctorName);
          setOfficeSelectValue(payload?.appointment?.officeName);
        }
      } else {
        if (payload.officeId && payload.doctorId) {
          let offices = await getOffices(payload.doctorId);
          payload.offices = offices?.length ? offices : [];
        }
      }
    } catch (err) {
      console.error("Error enriching payload:", err);
    }

    return payload;
  };

  let fetchInitial = async (patientId, claim) => {
    if (claim.status === "Unassigned") {
      return;
    }
    let claimIdd;
    if (patientId && claim?._id) {
      claimIdd = claim?._id;
      return await enrichPayload(claim.appointment);
    }
    if (onSubmit) {
      claimIdd = claimId;
    }
    if (patientId && claimIdd) {
      try {
        let res = await _axios.get(
          `${baseUrl}/patients/${patientId}/claims/${claimIdd}/appointment`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        return await enrichPayload(res.data.payload);
      } catch (err) {
        console.log(err);
        return {};
      }
    }
    return {};
  };

  const handleEditClose = () => {
    if (!isForm) {
      setIsEditing(false);
    }
  };

  useEffect(() => {
    setIsEditing(isForm);
    if (!isForm || isReschedule) {
      fetchInitial(patientId, claim)
        .then((payload) => {
          if (payload && Object.keys(payload)?.length) {
            setValues(payload);
          }
        })
        .catch((err) => {
          console.error("Error fetching initial data:", err);
        });
    } else {
      getDoctors()
        .then((payload) => {
          setDoctors(payload);
        })
        .catch((error) => {
          console.error("Error fetching doctors:", error);
        });
    }
  }, [patientId]);

  return (
    <Content className="w-full space-y-6">
      <form
        className={`w-full p-6 mb-6 ${
          isEditing
            ? "bg-gray-100 rounded-lg shadow-md"
            : "bg-white border border-gray-300 rounded-lg"
        }`}
        onSubmit={handleSubmit}
      >
        {/* Header Section */}
        <div className="flex justify-between items-center bg-gray-600 text-white p-4 rounded-t-lg">
          <h4 className="text-lg font-semibold">
            {isEditing ? "Schedule Appointment" : "Appointments"}
          </h4>
          {!isEditing && (
            <div className="flex items-center space-x-2">
              <div
                className="cursor-pointer hover:text-gray-200"
                onClick={() => setIsEditing(true)}
              >
                <EditOutlined className="text-xl" />
              </div>
            </div>
          )}
        </div>

        <div className="border border-gray-300 p-6 rounded-lg bg-white shadow-sm">
          {isEditing ? (
            <>
              <SearchDoctor
                formValues={formValues}
                setDoctorSelectValue={setDoctorSelectValue}
                setOfficeSelectValue={setOfficeSelectValue}
                setFormValues={setFormValues}
              />
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label={
                      <Typography.Title level={5}>
                        Assign Doctor
                      </Typography.Title>
                    }
                    layout="vertical"
                  >
                    <Select
                      value={doctorSelectValue}
                      onChange={doctorChangeHandler}
                      placeholder="--Select--"
                      className="w-full border border-gray-300 rounded-lg p-2"
                    >
                      <Option key="0" value="">
                        --Select--
                      </Option>
                      {formValues.doctors?.map((doctor) => (
                        <Option key={doctor._id} value={doctor._id}>
                          {doctor.physicianFirstName} {doctor.physicianLastName}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                {/* Select Office */}
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    label={
                      <Typography.Title level={5}>
                        Select Office
                      </Typography.Title>
                    }
                    layout="vertical"
                  >
                    <Select
                      value={officeSelectValue && officeSelectValue}
                      onChange={officeChangeHandler}
                      placeholder="--Select--"
                      className="w-full border border-gray-300 rounded-lg p-2"
                    >
                      <Option key="0" value="">
                        --Select--
                      </Option>
                      {formValues?.offices?.length > 0 &&
                        formValues?.offices?.map((office) => (
                          <Option key={office._id} value={office._id}>
                            {office.hospitalName}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[8, 8]}>
                {/* Select Date */}
                <Col xs={24} sm={8} md={6}>
                  <div className="flex flex-col">
                    <Typography.Text strong>Select Date</Typography.Text>
                    <DatePicker
                      className="w-full border border-gray-300 rounded-lg p-2 mt-1"
                      selected={selectedDate}
                      placeholderText="MM/DD/YYYY"
                      dateFormat="MM/dd/yyyy"
                      onChange={handleDateChange}
                      required
                    />
                  </div>
                </Col>

                {/* Select Time — driven by physician availability */}
                <Col xs={24} sm={8} md={6}>
                  <div className="flex flex-col">
                    <Typography.Text strong>Select Time</Typography.Text>
                    <div className="mt-1">
                      <SlotPicker
                        physicianId={doctorSelectValue}
                        hospitalId={officeSelectValue}
                        date={selectedDate}
                        value={selectedSlot}
                        onChange={(slot) => {
                          setSelectedSlot(slot);
                          setSelectedTime(slot ? slot.startTime : "");
                          setFormValues((prev) => ({
                            ...prev,
                            visitTime: slot ? slot.startTime : "",
                            visitEndTime: slot ? slot.endTime : null,
                          }));
                        }}
                        onNoSchedule={setNoSchedule}
                      />
                    </div>
                    {noSchedule && (
                      <input
                        type="time"
                        className="w-full border border-gray-300 rounded-lg p-2 mt-2"
                        value={selectedTime || ""}
                        onChange={handleTimeInputChange}
                        placeholder="Enter time manually"
                      />
                    )}
                  </div>
                </Col>

                {/* Description */}
                <Col xs={24} sm={8} md={12}>
                  <div className="flex flex-col">
                    <Typography.Text strong>
                      Description (Transportation scheduled)
                    </Typography.Text>
                    <TextArea
                      rows={2}
                      placeholder="Enter a description here..."
                      value={description}
                      onChange={handleDescriptionChange}
                      className="w-full border border-gray-300 rounded-lg p-2 mt-1"
                    />
                  </div>
                </Col>
              </Row>
              <div className="flex justify-end mt-4">
                <FormButtons
                  handleClose={isForm ? handleClose : handleEditClose}
                />
              </div>
            </>
          ) : noAppointments ? (
            <div className="text-gray-600 text-center py-4">
              No appointments to show
            </div>
          ) : (
            <div className="space-y-2 text-gray-700">
              <div>
                <b>Facility Provider: </b>
                {(() => {
                  const selectedDoctor = formValues.doctors?.find(
                    (doctor) => doctor._id === doctorSelectValue
                  );
                  return selectedDoctor
                    ? `${selectedDoctor.physicianFirstName || ""} ${
                        selectedDoctor.physicianLastName || ""
                      }`.trim()
                    : formValues.doctorName || "";
                })()}
              </div>
              <div>
                <b>Office: </b>
                {formValues.offices?.find(
                  (office) => office._id === officeSelectValue
                )?.name || formValues.officeName}
              </div>
              <div>
                <b>Appointment Date and Time: </b>
                {formValues.visitDate
                  ? formatDateForDisplay(formValues.visitDate)
                  : ""}{" "}
                {formValues.visitTime ? to12h(formValues.visitTime) : ""}
                {formValues.visitEndTime ? ` – ${to12h(formValues.visitEndTime)}` : ""}
              </div>
              <div>
                <b>Description: </b>
                {formValues.description || ""}
              </div>
              <div>
                <b>Report Due by Date: </b>
                {formValues.reportDueByDate
                  ? formatDateForDisplay(formValues.reportDueByDate)
                  : ""}
              </div>
            </div>
          )}
        </div>
      </form>
    </Content>
  );
};

export default AppointmentForm;
